import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Home from './page/home';
import UserForm from './page/userform';
import Header from './components/header';
import MudraApproval from './components/MudraApproval';
import Admin from './page/admin';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <div>
      <BrowserRouter>
      <Header/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/userform" element={<UserForm/>} />
<Route path="/mudraapproval" element={<MudraApproval/>} />
<Route
  path="/admin"
  element={
    <ProtectedRoute>
      <Admin />
    </ProtectedRoute>
  }
/>
       
        <Route path="*" element={<Home />} />
      </Routes>
      
      </BrowserRouter>



 
    </div>
  );
}

export default App;
